import { z } from 'zod';

export const serviceStatusDashboardSchema = z.object({}).strict().catch({});
